/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import UsuarioContext from '../../../context/usuario.context';
import FirebaseContext from '../../../context/firebase.context';
import ViewMessage from '../view.message';
import './inbox.scss';
import './inbox-mobile.scss';

function Inbox() {
  const { message: { selected }, setMessage, setTitle } = useContext(UsuarioContext);
  const { MarcarLida, ExcluirMensagem, listMessage } = useContext(FirebaseContext);

  return (
    <>
      {!selected
        ? (
          <div id="inbox">
            <div className="title-inbox">
              <div className="data">
                <span>
                  Data
                </span>
              </div>
              <div className="titulo">
                <span>
                  Titulo
                </span>
              </div>
              <div className="status">
                <span>
                  Status
                </span>
              </div>
              <div className="actions">
                <span>
                  Actions
                </span>
              </div>
            </div>
            <div className="body-inbox">
              {listMessage
                && listMessage.map((item, index) => {
                  const { title } = item || '';
                  const titleView = title?.length < 29 ? title : `${title?.substring(0, 28)}...`;
                  return (
                    <div className="content-inbox">
                      <div className="data-inbox">
                        {item?.read
                          ? <span>{item?.data || ''}</span>
                          : <strong>{item?.data || ''}</strong>}
                      </div>
                      <div className="title-inbox">
                        {item?.read
                          ? <span>{titleView || ''}</span>
                          : <strong>{titleView || ''}</strong>}
                      </div>
                      <div className="read-inbox">
                        {
                    (item?.read || false)
                      ? (
                        <>
                          {item?.read
                            ? (
                              <span>
                                {window.screen.width < 1000
                                  ? 'Lida'
                                  : 'Mensagem Lida'}
                              </span>
                            ) : (
                              <strong>
                                {window.screen.width < 1000
                                  ? 'Lida'
                                  : 'Mensagem Lida'}
                              </strong>
                            )}
                        </>
                      )
                      : (
                        <>
                          {item?.read
                            ? (
                              <span>
                                {window.screen.width < 1000
                                  ? 'Não Lida'
                                  : 'Mensagem não Lida'}
                              </span>
                            ) : (
                              <strong>
                                {window.screen.width < 1000
                                  ? 'Não Lida'
                                  : 'Mensagem não Lida'}
                              </strong>
                            )}
                        </>
                      )
                    }
                      </div>
                      <div className="actions-inbox">
                        <button
                          aria-label="Visualizar mensagem"
                          onClick={(e) => {
                            setMessage({
                              message: item.body,
                              selected: true,
                              data: item.data,
                            });
                            setTitle(item.title);
                            MarcarLida({ index, uid: item.uid });
                          }}
                          className="buttons-transparent"
                          type="button"
                        >
                          <i id={item?.uid || ''} className="fas fa-eye" />
                        </button>
                        <button
                          aria-label="Marcar como lida"
                          onClick={() => MarcarLida({ index, uid: item.uid })}
                          className="buttons-transparent"
                          type="button"
                        >
                          <i id={item?.uid || ''} className="fas fa-check-double" />
                        </button>
                        <button
                          aria-label="Excluir mensagem"
                          onClick={(e) => ExcluirMensagem({ uid: item.uid })}
                          className="buttons-transparent"
                          type="button"
                        >
                          <i id={item?.uid || ''} className="far fa-trash-alt" />
                        </button>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )
        : (
          <ViewMessage />
        )}
    </>
  );
}

export default Inbox;
